import React from "react";
import { Text, View, Platform, StyleSheet } from "react-native";

import IntegrationIcons from "../../common/icons/integrations";
import AppTheme from "../../AppTheme";

export default function MappingScore({ count }) {
  const width = Math.min(10 * count, 100);
  const remaining = Math.max(0, 10 - count);

  return (
    <View style={[styles.container]}>
      <View
        style={{
          alignItems: "center",
          marginVertical: 25,
        }}
      >
        <IntegrationIcons.MappingsBigIcon />
      </View>

      {remaining > 0 ? (
        <Text style={styles.headerText}>
          {remaining} more to go for better insights into your data
        </Text>
      ) : null}
      <View style={styles.progress}>
        <View style={[styles.complete, { width: `${width}%` }]} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingLeft: 18,
    paddingRight: 14,
  },
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 4,
    textAlign: "center",
  },
  progress: {
    position: "relative",
    height: 4,
    width: "100%",
    backgroundColor: "#DADADA",
    borderRadius: 3,
    marginBottom: 4,
  },
  complete: {
    position: "absolute",
    left: 0,
    top: 0,
    height: 4,
    width: "100%",
    borderRadius: 3,
    backgroundColor: "#23D7C1",
  },
});
